import React from 'react';
import { BoltIcon } from '@patternfly/react-icons';
import { PURPLE_GRADIENT, SUCCESS_GRADIENT, colors, radii, shadows } from '@app/components/designTokens';

interface LogoBadgeProps {
    /** size in px (square). Defaults to 56. */
    size?: number;
    /** 'brand' (purple bolt) | 'success' (green check disc, requires children). */
    variant?: 'brand' | 'success';
    children?: React.ReactNode;
    style?: React.CSSProperties;
}

const LogoBadge: React.FC<LogoBadgeProps> = ({ size = 56, variant = 'brand', children, style }) => {
    const isBrand = variant === 'brand';
    const wrapperStyle: React.CSSProperties = {
        width: size,
        height: size,
        borderRadius: isBrand ? radii.badge : '50%',
        background: isBrand ? PURPLE_GRADIENT : SUCCESS_GRADIENT,
        color: isBrand ? colors.boltGold : colors.success,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 18px',
        boxShadow: isBrand ? shadows.logoBadge : 'none',
        fontSize: Math.round(size * 0.45),
        ...style
    };

    return (
        <div style={wrapperStyle}>
            {children ?? <BoltIcon style={{ fontSize: Math.round(size * 0.5), color: colors.boltGold }} />}
        </div>
    );
};

export { LogoBadge };
